import { Action } from "../type";
import { Button } from "../atoms/Button";
import { useState } from "react";
import "../../assets/animation.css";
import { CardContent } from "../atoms/CardContent";
import cross from "../../assets/cross.webp";
import check from "../../assets/check.webp";

interface PropsCard {
  content: Action;
  onButtonTakeClick: () => void;
  onButtonDontTakeClick: () => void;
  onClosePopupClick: () => void;
}

export const Card = (props: PropsCard) => {
  const [showPopup, setShowPopup] = useState(false);
  const [beginAnimation, setBeginAnimation] = useState<boolean>(false);
  const [dontTakeAction, setDontTakeAction] = useState<boolean>(false);

  const onButtonDontTakeClick = () => {
    setBeginAnimation(true);
    setTimeout(() => {
      setShowPopup(true);
      setDontTakeAction(true);
    }, 200);
    props.onButtonDontTakeClick();
  };
  const onButtonTakeClick = () => {
    setBeginAnimation(true);
    setTimeout(() => {
      setShowPopup(true);
      setDontTakeAction(false);
    }, 200);
    props.onButtonTakeClick();
  };
  const onPopupClose = () => {
    setShowPopup(false);
    setTimeout(() => {
      setBeginAnimation(false);
    }, 1000);

    props.onClosePopupClick();
  };
  return (
    <div
      className={`p-5 w-[70%] h-fit text-center flex flex-col items-center rounded-[1em] justify-center bg-gradient-to-b from-white to-almost-true-gray ${
        showPopup
          ? beginAnimation
            ? "flip-vertical-right"
            : "flip-vertical-left"
          : "flip-vertical-right-shot"
      } ${
        showPopup && dontTakeAction && props.content.dontTakeAction.index < 0
          ? "shadow-2xl shadow-red-500"
          : showPopup &&
              dontTakeAction &&
              props.content.dontTakeAction.index > 0
            ? "shadow-2xl shadow-green-500"
            : showPopup && !dontTakeAction && props.content.takeAction.index < 0
              ? "shadow-2xl shadow-red-500"
              : showPopup &&
                  !dontTakeAction &&
                  props.content.takeAction.index > 0
                ? "shadow-2xl shadow-green-500"
                : showPopup &&
                    !dontTakeAction &&
                    props.content.takeAction.index < 0
                  ? "shadow-2xl shadow-red-500"
                  : ""
      }`}
    >
      {!showPopup ? (
        <div className="flip-vertical-right-shot">
          <CardContent
            title={props.content.title}
            image={props.content.image}
            description={props.content.description}
            buttons={
              <>
                <a className={`w-16`} onClick={onButtonDontTakeClick}>
                  <img alt={`not-ok-icon`} src={cross} />
                </a>
                <a className={`w-16`} onClick={onButtonTakeClick}>
                  <img alt={`ok-icon`} src={check} />
                </a>
              </>
            }
          />
        </div>
      ) : (
        <div className="flip-vertical-right-shot">
          <CardContent
            image={props.content.image}
            title={props.content.title}
            description={
              dontTakeAction
                ? props.content.dontTakeAction.text
                : props.content.takeAction.text
            }
            buttons={<Button label="Fermer" onClick={onPopupClose} />}
          />
        </div>
      )}
    </div>
  );
};
